import EstimateChip from "@/components/FitnessProfile/EstimateChip";
import { AppBar, Box, Toolbar, Typography, useTheme } from "@mui/material";
import { PLATFORM_ENUM } from "@WahooFitness/cloud-client-types";
import { useConfigContext } from "@WahooFitness/wahoo-offline-mfe";

function ResultsHeaderBar({
  athleteType,
  showHeaderBar,
  athleteTypeIcon,
  handleEstimateClick,
}: {
  athleteType?: string;
  showHeaderBar?: boolean;
  athleteTypeIcon?: JSX.Element;
  handleEstimateClick?: () => void;
}) {
  const { platform } = useConfigContext();
  const { palette } = useTheme();
  return (
    <AppBar
      color={showHeaderBar ? undefined : "transparent"}
      sx={{
        boxShadow: "none",
        transition: "all .5s ease",
        WebkitTransition: "all .5s ease",
        MozTransition: "all .5s ease",
        borderBottom: showHeaderBar ? `1px solid ${palette.dividerSubtle}` : "none",
      }}
    >
      <Toolbar
        variant={platform === PLATFORM_ENUM.ios ? "ios" : "regular"}
        sx={{ justifyContent: "center" }}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="flex-start"
          width="100%"
          paddingY={2}
          paddingX={1}
          maxWidth="sm"
        >
          {showHeaderBar && (
            <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
              <Box display="flex" alignItems="center">
                <Typography variant="ui-4xl-bold">{athleteType}</Typography>
                <Box ml={1.5} justifyContent="center" height={24}>
                  {athleteTypeIcon}
                </Box>
              </Box>
              <EstimateChip handleClick={handleEstimateClick} />
            </Box>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default ResultsHeaderBar;
